import { render, staticRenderFns } from "./onNttp.vue?vue&type=template&id=644903b4"
import script from "./onNttp.vue?vue&type=script&lang=js"
export * from "./onNttp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports